import { render, staticRenderFns } from "./StumpyDiv.vue?vue&type=template&id=5b2c4718"
import script from "./StumpyDiv.vue?vue&type=script&lang=js"
export * from "./StumpyDiv.vue?vue&type=script&lang=js"
import style0 from "./StumpyDiv.vue?vue&type=style&index=0&id=5b2c4718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports